import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'

//import components
import { Arrow } from '../svgs/Arrow'

//styled components
const ArrowBlockWrapper = styled.div`
	background: ${({ theme }) => theme.colors.secondary};
	width: ${({ blockWidth }) => blockWidth || '60px'};
	height: ${({ blockHeight }) => blockHeight || '60px'};
	position: ${({ position }) => position};
	right: 0;
	bottom: 0;
	padding: 0;
	transition: all 0.4s ease;
`
export const ArrowWrapper = styled.div`
	display: flex;
	margin: auto;
	transform: rotate(270deg);
	padding: ${({ padding }) => padding || '0'};
`

ArrowBlock.propTypes = {
	arrowHeight: string,
	arrowWidth: string,
	blockHeight: string,
	blockWidth: string,
	position: string,
	arrowMargin: string,
	arrowPadding: string,
	boxPadding: string,
}

/**
 * This is a reusable block component containing an arrow svg. It
 * accepts width and height of both block and arrow as props
 */
export function ArrowBlock({
	blockWidth,
	blockHeight,
	arrowWidth = 20,
	arrowHeight = 20,
	position = 'absolute',
	arrowMargin,
	arrowPadding,
	boxPadding,
}) {
	return (
		<ArrowBlockWrapper
			blockWidth={blockWidth}
			blockHeight={blockHeight}
			position={position}
			boxPadding={boxPadding}
		>
			<ArrowWrapper arrowWidth={arrowWidth} arrowHeight={arrowHeight} margin={arrowMargin} padding={arrowPadding}>
				<Arrow width={arrowWidth} height={arrowHeight} />
			</ArrowWrapper>
		</ArrowBlockWrapper>
	)
}
